// File for logic corresponding to article-list-carousel component
import { Component } from 'js-component-framework';
import splitChars from 'utils/splitChars';
import './closings-page.scss';

/**
 * Component for closings-page
 */
export default class ClosingsPage extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    const { closingsNavItems, splittedChars, toggle } = this.children;
    this.toggleJumpMenu = this.toggleJumpMenu.bind(this);
    this.closeJumpMenuOnItemClick = this.closeJumpMenuOnItemClick.bind(this);

    if (toggle) {
      toggle.addEventListener('click', this.toggleJumpMenu);
    }

    if (closingsNavItems) {
      closingsNavItems.addEventListener('click', this.closeJumpMenuOnItemClick);
    }

    if (0 < splittedChars.length) {
      splittedChars.forEach((el) => splitChars(el));
    }
  }

  /**
   * Toggle the jump menu to a open/close state.
   */
  toggleJumpMenu() {
    const { closingsNav, toggleIconClose, toggleIconDefault } = this.children;
    const { menuActiveClass } = this.options;
    const siteContent = document.getElementById('content');

    if (! closingsNav) {
      return;
    }

    if (closingsNav.classList.contains(menuActiveClass)) {
      siteContent.style.position = 'relative'; // enable z-index context.
      closingsNav.classList.remove(menuActiveClass);
      toggleIconClose.setAttribute('aria-hidden', 'true');
      toggleIconDefault.removeAttribute('aria-hidden');
    } else {
      siteContent.style.position = 'static'; // disable z-index context.
      closingsNav.classList.add(menuActiveClass);
      toggleIconDefault.setAttribute('aria-hidden', 'true');
      toggleIconClose.removeAttribute('aria-hidden');
    }
  }

  /**
   * Close the jump menu upon clicking a nav item.
   *
   * @param {Event} e Event.
   */
  closeJumpMenuOnItemClick(e) {
    const { closingsNav } = this.children;
    const { menuActiveClass } = this.options;

    if (! closingsNav.classList.contains(menuActiveClass)) {
      return;
    }

    if (e.target && e.target.classList.contains('closings-nav__item')) {
      this.toggleJumpMenu();
    }
  }
}
